import { render, staticRenderFns } from "./CreateCampaignSetupsSchedule.vue?vue&type=template&id=0b5ce52f&scoped=true"
import script from "./CreateCampaignSetupsSchedule.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSetupsSchedule.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSetupsSchedule.vue?vue&type=style&index=0&id=0b5ce52f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5ce52f",
  null
  
)

export default component.exports